import './ChipDeleteButton.css';
export var base = '_19l3siz0-2-0-1';
export var size = {'default':'_19l3siz1-2-0-1',condensed:'_19l3siz2-2-0-1'};